// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpdateSection/UpdateSection.css
// module id = 994
// module chunks = 0